module.exports = __webpack_public_path__ + "static/img/beans.3b48783e.png";